import React from 'react';
import { Link } from 'react-router-dom';

const ActionContainer = () => {
  return (
    <div className="text-right">
      <Link
        to="/dashboard"
        className="btnSizes transparentBtn border-0"
      >
        Cancel
      </Link>
      <button
        type="submit"
        className="btnSizes filledBtn ml-5"
      >
        Update Profile
      </button>
    </div>
  )
}

export default ActionContainer;